import { FC, useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Card from 'components/UI/Card';
import { CardHeaderTop, CardHeaderTopColumn } from 'pages/Connectivity/styled';
import Heading, { Type as HeadingType } from 'components/UI/Heading';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import Loader from 'components/UI/Loader';
import DigitalTwinTree from '../DigitalTwinTree';
import { ConnectivityDetails } from 'models';
import {
  connectivityDetailsSelector,
  fetchDigitalTwin,
} from 'store/connectivityState/connectivityState';

type Props = {
  id: string;
};
const DigitalTwinCard: FC<Props> = ({ id }) => {
  const dispatch = useAppDispatch();
  const { digitalTwin }: ConnectivityDetails = useAppSelector(
    connectivityDetailsSelector
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchDigitalTwin(id));
    }
  }, [dispatch, id]);

  const twinResult = useMemo(() => {
    if (digitalTwin.isLoading) {
      return <Loader center />;
    }
    if (digitalTwin.error) {
      return <Heading type={HeadingType.h4}>{digitalTwin.error.title}</Heading>;
    }

    return <DigitalTwinTree digitalTwin={digitalTwin.data} />;
  }, [digitalTwin]);

  return (
    <Card>
      <CardHeaderTop>
        <CardHeaderTopColumn>
          <Heading type={HeadingType.h3} uppercase>
            <FormattedMessage id="connectivity.digital_twin" />
          </Heading>
        </CardHeaderTopColumn>
      </CardHeaderTop>
      {twinResult}
    </Card>
  );
};

export default DigitalTwinCard;
